const burger = $('.js-burger');
const header = $('.js-header');
const overlay = $('.js-overlay');
const menuLink = $('.header__nav .nav a');

function open() {
  burger.addClass('is-active');
  header.addClass('is-active');
  overlay.addClass('is-active');
  $('html').addClass('overflow');
}

function close() {
  burger.removeClass('is-active');
  header.removeClass('is-active');
  overlay.removeClass('is-active');
  $('html').removeClass('overflow');
}

burger.on('click', function () {
  if (header.hasClass('is-active')) {
    close();
  } else {
    open();
  }
});

menuLink.on('click', function () {
  if (header.hasClass('is-active')) {
    close();
  }
});
